/* eslint-disable import/prefer-default-export */
export const getTotalSaleRangeDates = state => state.totalSaleRangeDates
export const getRegisteredPaymentsRangeDates = state => state.registeredPaymentsRangeDates
